export default __webpack_public_path__ + "b7452bb3562c750765e330267ce1b29f.svg";